import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { CheckboxGroupFieldWUT } from '../../../ui/checkbox-group-field';
import { useServicesMultiChoiceOptions } from '../utils/use-services-multi-choice-options';
export const ServicesMultiChoiceWUT = props => {
  const fieldType = FIELD_TYPES.SERVICES_MULTI_CHOICE;
  const {
    options,
    isEmpty,
    shouldRender
  } = useServicesMultiChoiceOptions(props);
  if (!props.isEditor && isEmpty) {
    return null;
  }
  if (!shouldRender) {
    return null;
  }
  return /*#__PURE__*/React.createElement(CheckboxGroupFieldWUT, _extends({}, props, {
    fieldType: fieldType,
    value: props.value || [],
    options: options
  }));
};
//# sourceMappingURL=services-multi-choice-wut.js.map